import {makeAdUrl} from '@frontend/helpers'
import {AdCommunicationButtons} from '@frontend/modules/public/ads/components/details/AdCommunicationButtons'
import {AdsListItemImageAndIcons} from '@frontend/modules/public/ads/components/list/AdsListItemImageAndIcons'
import {AdsListItemInfo} from '@frontend/modules/public/ads/components/list/AdsListItemInfo'
import {SellerInfo} from '@frontend/modules/public/seller_info/components/SellerInfo'
import clsx from 'clsx'
import type {MouseEvent} from 'react'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'
import type {AdPreviewDataForList} from '../../AdsModuleTypes'

interface AdsListItemProps {
    ad: AdPreviewDataForList
    gridOrder?: number
    className?: string
    onAdDataChange: (ad: AdPreviewDataForList) => void
}

// Карточка предпросмотра объявления.
export function AdsListItem(props: AdsListItemProps) {

    const {
        ad,
        gridOrder = 0,
        className,
        onAdDataChange,
    } = props

    // Обработчик нажатия на карточку объявления.
    const onCardClick = useEventCallback((
        e: MouseEvent<HTMLElement>
    ) => {
        // Check if the clicked element or any of its parents is an <a> or <button>
        let element: HTMLElement | null = e.target as HTMLElement | null
        while (element && element !== e.currentTarget) {
            if (
                element.tagName === 'A'
                || element.tagName === 'BUTTON'
                || element.hasAttribute('href')
                || typeof element.onclick === 'function'
            ) {
                return
            }
            element = element.parentElement
        }
        AnalyticsEventReporter.clickOnAdFromList(ad)
        window.open(makeAdUrl(ad.id), '_blank')
    })

    return (
        <Card
            className={clsx(
                'offered-item-card presentation-list cursor',
                ad.isPromoted ? 'promoted border border-2 border-orange' : null,
                className
            )}
            style={{
                order: gridOrder,
            }}
            onClick={onCardClick}
        >
            <CardBody
                className={clsx(
                    'p-3',
                    'd-flex flex-column gap-3 align-items-stretch justify-content-start',
                    'flex-xxl-row gap-xxl-4 align-items-xxl-start'
                )}
            >
                <div
                    className={clsx(
                        'd-flex flex-column gap-3 align-items-stretch justify-content-start',
                        'flex-sm-row gap-sm-4 align-items-sm-start',
                        'flex-md-column gap-md-3 align-items-md-stretch',
                        'flex-lg-row gap-lg-4 align-items-lg-start',
                        'flex-xxl-1 flex-xxl-row gap-xxl-4 align-items-xxl-start'
                    )}
                >
                    <AdsListItemImageAndIcons ad={ad} />
                    <AdsListItemInfo ad={ad} />
                </div>
                <div
                    className={clsx(
                        'offered-item-card-seller-and-actions',
                        'pt-2 d-flex flex-column gap-3 align-items-center',
                        'pt-sm-3 flex-sm-row justify-content-sm-between align-items-sm-start',
                        'pt-md-2 flex-md-column justify-content-md-start align-items-md-center',
                        'pt-lg-3 flex-lg-row justify-content-lg-between align-items-lg-start',
                        'pt-xxl-0 flex-xxl-column gap-xxl-2 justify-content-xxl-start align-items-xxl-start'
                    )}
                >
                    <SellerInfo
                        seller={ad.seller}
                        noAvatar
                        categoryType={ad.categoryType}
                        className="offered-item-card-seller pe-2 full-width"
                        ratingBlockClassName="mt-0"
                        registrationDateClassName="mt-0 text-start"
                    />
                    <AdCommunicationButtons<AdPreviewDataForList>
                        ad={ad}
                        condensed
                        onAdDataChange={onAdDataChange}
                        className={clsx(
                            'offered-item-card-actions',
                            'd-flex flex-column gap-3 align-items-center',
                            'full-width-xs-only',
                            'full-width-md-only',
                            'mt-xxl-1 full-width-xxl-up d-xxl-flex flex-xxl-column'
                        )}
                        buttonClassName="full-width flex-row-between"
                    />
                </div>
            </CardBody>
        </Card>
    )
}
